import loadable from '@loadable/component';

export const GenplanPopupLoadable = loadable(() => import('./GenplanPopup'));
